import {baseUrl} from'../config';

export const classController ={
    GetAllClasses:baseUrl+'/api/class'
} 